import React from 'react';
import { observer } from 'mobx-react';
import { Upgrade } from './Upgrade';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';

export const SelectUpgrades = observer(() => {
	const { parkingProductsQuoteStore } = useNewBookingStore();
	const { upgrades } = parkingProductsQuoteStore;

	if (!upgrades.length) {
		return null;
	}

	return (
		<>
			{upgrades.map((upgrade) => (
				<Upgrade key={upgrade.id} upgrade={upgrade} />
			))}
		</>
	);
});
